import { css } from "@emotion/css";
import { Close } from "@mui/icons-material";
import { Box, IconButton, TextField } from "@mui/material";
import { FC } from "react";

interface NumberRangeFilterProps {
  label: string;
  startNum: number;
  endNum: number;
  onChange: (startNum, endNum) => void;
}

const NumberRangeFilter: FC<NumberRangeFilterProps> = ({
  label,
  startNum,
  endNum,
  onChange,
}) => {
  const handleStartNum = (event) => {
    const newNum = event.target.value;
    // if the value is a blank (a user manually deleted the value),
    // we need to send a null
    onChange(newNum ? newNum : null, endNum);
  };

  const handleEndNum = (event) => {
    const newNum = event.target.value;
    onChange(startNum, newNum ? newNum : null);
  };

  const handleResetValue = (start) => {
    if (start) {
      onChange(null, endNum);
    } else {
      onChange(startNum, null);
    }
  };

  const ResetValueButton = ({ start = false }) => (
    <IconButton
      sx={{
        padding: "0",
        "&:hover": {
          backgroundColor: "transparent",
          border: "none",
        },
      }}
      onClick={() => handleResetValue(start)}
    >
      <Close />
    </IconButton>
  );

  return (
    <Box
      sx={{
        display: "inline-flex",
        flexDirection: "row",
        alignItems: "end",
        height: 48,
      }}
    >
      <TextField
        name="lower-bound-input"
        placeholder="From"
        label={label}
        variant="standard"
        type="number"
        value={startNum || undefined}
        onChange={handleStartNum}
        sx={{ mr: 2 }}
        slotProps={{
          inputLabel: { shrink: true },
          input: { endAdornment: startNum ? <ResetValueButton start /> : null },
        }}
      />
      <span className={css({ paddingRight: "1rem" })}>&mdash;</span>
      <TextField
        name="upper-bound-input"
        placeholder="To"
        variant="standard"
        type="number"
        value={endNum || undefined}
        onChange={handleEndNum}
        slotProps={{
          input: { endAdornment: endNum ? <ResetValueButton /> : null },
        }}
      />
    </Box>
  );
};

export default NumberRangeFilter;
